import './style.scss'
import React from 'react'
import { rem } from 'src/componentv2/Base/ui'

export interface IconCircleProps {
    children: React.ReactNode
    size?: string                // rem
    bgColor?: string
    borderColor?: string
    className?: string
}

export const IconCircle: React.FC<IconCircleProps> = ({
                                                          children, size = '7', bgColor = '#D1FADF', borderColor, className = '',
                                                      }) => (
    <span
        className={`iconcircle ${className}`}
        style={{
            width: rem(size),
            height: rem(size),
            background: bgColor,
            border: borderColor ? `1px solid ${borderColor}` : undefined,
        }}
    >
        {children}
    </span>
)

export default IconCircle